import { getUser } from '~src/user';

export const initSalesIqChat = async () => {
  const { user } = await getUser();

  return new Promise((resolve, reject) => {
    // Initialize $zoho object if not already present
    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || {
      ready: function () {
        window.$zoho.salesiq.chat.waittime(600);
        window.$zoho.salesiq.domain('onoranzefunebricloud.com');

        window.$zoho.salesiq.floatbutton.visible('hide');

        // Attiva il chat quando l'agente invia un messaggio
        window.$zoho.salesiq.chat.agentMessage(function () {
          window.$zoho.salesiq.floatwindow.visible('show');
        });
      },
      afterReady: function () {
        // Identifica l'utente con dati dal tuo sistema
        window.$zoho.salesiq.visitor.id(user.objectId);
        window.$zoho.salesiq.visitor.name(
          `${user.first_name} ${user.last_name}`
        );
        window.$zoho.salesiq.visitor.email(user.username);

        if (user.telefono) {
          window.$zoho.salesiq.visitor.contactnumber(user.telefono);
        }

        // Attiva il tracciamento
        window.$zoho.salesiq.tracking.on();
      },
    };

    // Check if script is already loaded
    if (document.getElementById('zsiqscript')) {
      resolve();
      return;
    }

    // Create and load the script
    const script = document.createElement('script');
    script.id = 'zsiqscript';
    script.src =
      'https://salesiq.zohopublic.eu/widget?wc=siqcdccb168c67bb575994fb8d0751db1ca296ba50cabd1752fb1dd16523bfd5e1d1fbec27802e7a4f8de8012fae423b7e0';
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error('Failed to load Zoho Sales IQ script'));

    document.head.appendChild(script);
  });
};
